import React, { Component, PropTypes } from 'react';
import shallowCompare from 'react-addons-shallow-compare';
import { displayCreationModal } from 'saas/contacts/modals';
import cx from 'classnames';
import { connect } from 'react-redux';
import { addContact, selectContact } from '../actions/contacts';
import { getContacts } from '../reducers/contacts';
import { getSites } from '../reducers/sites';
import {
  getSelectedContacts,
  getSelectedSites,
  getCustomerId,
  getErrors,
} from '../reducers/form';
import { Form } from 'semantic-ui-react';
import ContactSelectorItem from './ContactSelectorItem';

export class ContactSelector extends Component {
  constructor(props) {
    super(props);

    this.state = {};
    this._onAddContact = this._onAddContact.bind(this);
  }

  _onAddContact(evt) {
    evt.stopPropagation();
    evt.preventDefault();

    const onSaved = this.props.onAdded;

    // Displaying contact modal
    displayCreationModal(this.props.customer, onSaved);
  }

  shouldComponentUpdate(nextProps) {
    return shallowCompare(this, nextProps);
  }

  render() {
    const {
      sites,
      selectedSiteIds,
      selected,
      onSelected,
      errors,
      contacts,
    } = this.props;

    const hasError = (global = false) => {
      if (errors) {
        return errors.includes('contactIds');
      }
      return false;
    };

    const onContactChange = siteId => (contactId, value) => {
      onSelected(siteId, contactId);
    };

    const segmentClasses = cx('ui segment form', {
      error: hasError(),
    });

    const selectedSites = sites.filter(s => selectedSiteIds.includes(s.id));

    const getContact = site => {
      const found = selected.find(s => s.site === site.id);
      if (found) {
        return found.contact.toString(10);
      } else {
        return '';
      }
    };

    return (
      <div className={segmentClasses}>
        <h3 className="ui header">
          Choix du contact site
          <button
            className="ui right floated labeled icon button"
            onClick={this._onAddContact}
          >
            <i className="icon add" />
            Créer un nouveau contact
          </button>
        </h3>
        {hasError(true) && (
          <div className="ui error message">
            <p>Vous devez sélectionner un contact par site.</p>
          </div>
        )}
        <br />
        <Form.Field>
          <label>Contact site</label>
          {selectedSites.map(site => (
            <ContactSelectorItem
              key={site.id}
              site={site}
              value={getContact(site)}
              contacts={contacts}
              onChange={onContactChange(site.id)}
            />
          ))}
        </Form.Field>
      </div>
    );
  }
}

ContactSelector.propTypes = {
  sites: PropTypes.array.isRequired,
  selectedSiteIds: PropTypes.array.isRequired,
  contacts: PropTypes.array.isRequired,
  selected: PropTypes.array.isRequired,
  onAdded: PropTypes.func.isRequired,
  onSelected: PropTypes.func.isRequired,
  errors: PropTypes.array.isRequired,
};

const mapStateToProps = state => ({
  sites: getSites(state),
  selectedSiteIds: getSelectedSites(state),
  contacts: getContacts(state),
  selected: getSelectedContacts(state),
  customer: getCustomerId(state),
  errors: getErrors(state),
});

const mapDispatchToProps = dispatch => ({
  onSelected: (site, contact) => dispatch(selectContact(site, contact)),
  onAdded: contact => dispatch(addContact(contact)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ContactSelector);



// WEBPACK FOOTER //
// ./src/modules/saas/pco/cases-creation/step1/components/ContactSelector.js